import "./Footer.css";
import cv from "../assets/documents/Harry_AZAMOSA_CV.pdf";

function Footer() {
  function notification() {
    new Notification("Harry Azamosa Portfolio", {
      body: `The curriculum vitae of Harry Azamosa Osawayemen has been downloaded to your local device storage`,
    });
  }

  return (
    <div className="footer">
      <div>
        <a href={cv} download target="_blank" onClick={notification}>
          <p>Download CV</p>
        </a>
        <h3>|</h3>
        <p
          onClick={() =>
            (window.location =
              "mailto:johnharry@gmail.com?subject=Access request")
          }
        >
          Johnharry238@gmail.com
        </p>
        <h3>|</h3>
        <a
          href="https://www.linkedin.com/in/harry-azamosa-525087149"
          target="_blank"
        >
          <p>Linkedin</p>
        </a>
      </div>
      <section>
        <p>&copy; 2026 Harry Azamosa. All rights reserved.</p>
      </section>
    </div>
  );
}

export default Footer;
